import SdfaWorkflowSummary from 'forms/containers/Sdfa/WorkflowSummary';
export default SdfaWorkflowSummary;
